/** WorkOrder ekraninin MailOrbit e-mail sekmesi (src/views/WorkOrder/index.js: value 'MailOrbitEmail'). */
export const workOrderEmailPath = workOrderId => `/WorkOrder/${workOrderId}/MailOrbitEmail`;

/** GET MailOrbitWorkOrder/{id} yanitindan: acik bagli is emri numarasi, yoksa null. */
export const openWorkOrderId = link =>
  link && link.hasWorkOrder && link.workOrderId && link.isClosed !== true ? link.workOrderId : null;

/** Bagli ama KAPALI is emri numarasi, yoksa null. */
export const closedWorkOrderId = link =>
  link && link.hasWorkOrder && link.workOrderId && link.isClosed === true ? link.workOrderId : null;
